const MarketUnitForPropertySelect = ({
    listingAlias = '',
    floorPlanId = '',
    floorPlanName = '',
    unitId = '',
    unitName = '',
    active = false,
} = {}) => ({
    listingAlias: String(listingAlias),
    floorPlanId: String(floorPlanId),
    floorPlanName: String(floorPlanName),
    unitId: String(unitId),
    unitName: String(unitName),
    active: Boolean(active),
});

const MarketUnitsForPropertySelect = (
    unitsByFloorplanName = {},
) => ({
    unitsByFloorplanName: Object.entries(unitsByFloorplanName).reduce((newObject, [floorPlanName, units]) => {
        newObject[floorPlanName] = units.map(unit => new MarketUnitForPropertySelect(unit));
        return newObject;
    }, {}),
});

export default MarketUnitsForPropertySelect;
